import Modal from '../../atoms/Modal';
import StateView from '../../atoms/State';
import { BaseModalData } from '../../types/Modals';
import { EmailInboxInstructionsPage } from './index';
import { useCallback } from 'react';
import { useDataSubscribion } from '../../hooks/useDataSubscribion';
import * as types from '../../types/Types';
import { useTranslation } from 'react-i18next';

export interface EmailInboxInstructionsModalData extends BaseModalData {
    emailInboxId: types.FormId;
}

export function EmailInboxInstructionsModal(props: {
    onClose: () => void;
    data: EmailInboxInstructionsModalData;
    index: number;
    onFocus: VoidFunction;
}) {
    const { t } = useTranslation();
    const { state, revalidate } = useDataSubscribion(
        useCallback((x) => x.subscribeForForm(props.data.emailInboxId), [props.data.emailInboxId])
    );
    return (
        <Modal
            index={props.index}
            onFocus={props.onFocus}
            onClose={props.onClose}
            height={props.data.height ?? 700}
            minHeight={440}
            width={props.data.width}
            title={props.data.title ?? t('modal.emailInboxInstructions.title')}>
            <StateView state={state} retry={revalidate}>
                {(data) => <EmailInboxInstructionsPage emailInbox={data.form} />}
            </StateView>
        </Modal>
    );
}
